module.exports = __webpack_public_path__ + "img/phone-bold.f394afa2.svg";